import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Zap, Loader2 } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { document.title = "Giriş Yap — kisalink.net"; }, []);
  useEffect(() => { if (user) navigate("/dashboard", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      toast.success("Hoş geldiniz!");
      navigate(data.user.role === "admin" ? "/link" : "/dashboard");
    } catch (err) {
      toast.error(apiErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center kl-gradient px-4">
      <Card className="w-full max-w-md p-8 rounded-2xl shadow-xl border-slate-200 kl-fade-up">
        <Link to="/" className="flex items-center gap-2 justify-center mb-6">
          <span className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center"><Zap className="w-5 h-5 text-white" fill="white" /></span>
          <span className="font-display text-lg font-extrabold">kisalink<span className="text-blue-600">.net</span></span>
        </Link>
        <h1 className="text-2xl font-bold text-center font-display">Tekrar hoş geldiniz</h1>
        <p className="text-sm text-slate-500 text-center mt-1 mb-6">Panele erişmek için giriş yapın</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="mb-1.5 block">E-posta</Label>
            <Input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ornek@mail.com" className="h-11" />
          </div>
          <div>
            <Label className="mb-1.5 block">Şifre</Label>
            <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-11" />
          </div>
          <Button data-testid="login-submit-button" type="submit" disabled={loading} className="w-full h-11 bg-blue-600 hover:bg-blue-700">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Giriş Yap"}
          </Button>
        </form>

        <div className="flex items-center gap-3 my-5">
          <div className="h-px bg-slate-200 flex-1" /><span className="text-xs text-slate-400">veya</span><div className="h-px bg-slate-200 flex-1" />
        </div>
        <Button variant="outline" onClick={google} className="w-full h-11" data-testid="login-google-button">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-4 h-4 mr-2" /> Google ile devam et
        </Button>

        <p className="text-sm text-center text-slate-500 mt-6">
          Hesabınız yok mu? <Link to="/register" className="text-blue-600 font-semibold" data-testid="goto-register">Kayıt olun</Link>
        </p>
      </Card>
    </div>
  );
}
